function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.942 12.432l-.929-2.704a6.779 6.779 0 00.686-2.959 6.718 6.718 0 00-1.94-4.743A6.712 6.712 0 009.05 0a6.707 6.707 0 00-4.888 1.978A6.702 6.702 0 002.183 6.67 4.926 4.926 0 00.69 12.721l-.64 1.863c-.11.32-.03.668.21.907a.873.873 0 00.907.21l1.862-.64c.655.31 1.378.474 2.106.475h.008a4.917 4.917 0 003.976-2.022 6.78 6.78 0 002.792-.683l2.705.929a1.038 1.038 0 001.078-.25c.285-.284.38-.697.25-1.078zm-10.8 2.152h-.007c-.644-.001-1.284-.16-1.85-.46a.478.478 0 00-.377-.029l-1.91.656.656-1.91a.476.476 0 00-.03-.377 3.968 3.968 0 01.647-4.604c.231 1.404.9 2.697 1.937 3.716a6.723 6.723 0 003.72 1.865 3.96 3.96 0 01-2.786 1.143zm9.878-1.747a.086.086 0 01-.096.022l-2.895-.995a.479.479 0 00-.377.03c-.827.437-1.761.669-2.702.67h-.009c-3.152 0-5.755-2.56-5.805-5.711a5.762 5.762 0 011.7-4.2 5.763 5.763 0 014.2-1.7c3.154.05 5.716 2.658 5.711 5.815a5.818 5.818 0 01-.67 2.701.478.478 0 00-.03.377l.995 2.896a.087.087 0 01-.022.095z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.778 4.234H6.104a.476.476 0 000 .953h5.674a.476.476 0 000-.953zM11.778 6.193H6.104a.476.476 0 000 .952h5.674a.476.476 0 000-.952zM9.594 8.151h-3.49a.476.476 0 000 .953h3.49a.476.476 0 000-.953z"
});

function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgFeedback;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/feedback.svg
// module id = 1287
// module chunks = 10